// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2J-6B","tab":"ProcedureTabs_tab__1KVAE"};